import { render, staticRenderFns } from "./ChatHome.vue?vue&type=template&id=4a355896&"
import script from "./ChatHome.vue?vue&type=script&lang=js&"
export * from "./ChatHome.vue?vue&type=script&lang=js&"
import style0 from "./ChatHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports